import { Paragraph as n } from "../../node_modules/@tiptap/extension-paragraph/dist/index.mjs";
import { ReactNodeViewRenderer as s } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { convertStyleObjectToCss as m } from "../../utils/style-helpers.mjs";
import { PARAGRAPH_EXTRA_SPACING_ATTRIBUTE as e } from "./constants.mjs";
import { CustomParagraphNodeView as p } from "./custom-paragraph-node-view.mjs";
import { getParagraphStyles as c } from "./utils.mjs";
import { mergeAttributes as d } from "../../node_modules/@tiptap/core/dist/index.mjs";
const i = (r) => r !== "0" && r !== "0px" && r !== "0rem" && r !== "0em" && r !== 0 && r !== "" && r !== null && r !== void 0 && r !== " ", R = n.extend({
  addAttributes() {
    var r;
    return {
      ...(r = this.parent) == null ? void 0 : r.call(this),
      [e]: {
        default: !1,
        parseHTML: (t) => {
          if (!t.style) return !1;
          const o = i(t.style.marginTop), a = i(t.style.marginBottom);
          return o && a;
        }
      }
    };
  },
  addNodeView() {
    return s(p);
  },
  renderHTML({ HTMLAttributes: r, node: t }) {
    const o = t.attrs[e], a = t.content.size === 0;
    return [
      "p",
      d(
        {
          dir: "auto",
          style: m(c(o))
        },
        r
      ),
      a ? ["br", { class: "trailingBreak" }] : 0
    ];
  }
});
export {
  R as ParagraphExtension
};
